module.exports = __webpack_public_path__ + "static/media/share-icon.88023d6c.svg";